// import React, { useState, useEffect } from "react";
// import { createUser, getUserData } from "../firebase/firestoreService";
// import { useNavigate } from "react-router-dom";

// const FirstTimeLogin = ({ email }) => {
//   const [number, setNumber] = useState("");
//   const [place, setPlace] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       const userData = await getUserData(email);
//       if (userData) {
//         if (userData.number) setNumber(userData.number);
//         if (userData.place) setPlace(userData.place);
//       }
//     };
//     fetchData();
//   }, [email]);

//   const handleSubmit = async () => {
//     const userData = { number, place, mailid: [email], npk: [0, 0, 0], farmerid: "" };
//     await createUser(email, userData);
//     alert("User data saved!");
//     navigate("/dashboard");
//   };

//   return (
//     <div>
//       <h2>Complete Your Profile</h2>
//       <input
//         type="text"
//         placeholder="Number"
//         value={number}
//         onChange={(e) => setNumber(e.target.value)}
//       />
//       <input
//         type="text"
//         placeholder="Place"
//         value={place}
//         onChange={(e) => setPlace(e.target.value)}
//       />
//       <button onClick={handleSubmit}>Submit</button>
//     </div>
//   );
// };

// export default FirstTimeLogin;
import React, { useState, useEffect } from "react";
import { createUser, getUserData } from "../firebase/firestoreService";
import { useNavigate } from "react-router-dom";
import LoadingPage from "./LoadingPage";

const style = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#f0f5f1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(5px)",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
    filter: "brightness(80%)", // Darken video for better contrast
  },
  formContainer: {
    background: "rgba(255, 255, 255, 0.3)",
    backdropFilter: "blur(10px)",
    padding: "15px 30px",
    borderRadius: "15px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
    maxWidth: "320px",
    width: "80%",
    border: "2px solid #f1f8e9",
  },
  h2: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: "1.6rem",
    marginBottom: "12px",
    color: "#FFFFFF",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.4)",
  },
  input: {
    width: "100%",
    padding: "10px",
    margin: "8px 0",
    borderRadius: "8px",
    border: "1px solid #FFFFFF",
    fontSize: "14px",
    backgroundColor: "#F1F8E9",
    boxSizing: "border-box",
    transition: "all 0.3s ease",
    outline: "none",
    color: "#333",
  },
  inputFocus: {
    borderColor: "#66bb6a",
    boxShadow: "0 0 6px rgba(102, 187, 106, 0.6)",
  },
  button: {
    width: "100%",
    padding: "12px",
    margin: "10px 0",
    borderRadius: "8px",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    backgroundColor: "#66bb6a",
    color: "white",
    fontWeight: "bold",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.2s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  alert: {
    color: "red",
    fontSize: "12px",
    marginTop: "8px",
  },
  loadingText: {
    color: "#FFFFFF",
    fontSize: "1rem",
    marginTop: "20px",
  },
};

const FirstTimeLogin = ({ email }) => {
  const [number, setNumber] = useState("");
  const [place, setPlace] = useState("");
  const [loading, setLoading] = useState(true); // Track loading state
  const [isSubmitting, setIsSubmitting] = useState(false); // Track submitting state
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userData = await getUserData(email);
      if (userData) {
        if (userData.number) setNumber(userData.number);
        if (userData.place) setPlace(userData.place);
      }
      setLoading(false); // Set loading to false once data is fetched
    };
    fetchData();
  }, [email]);

  const handleSubmit = async () => {
    if (!number || !place) {
      alert("Please fill in both fields");
      return;
    }

    setIsSubmitting(true); // Start the submission process
    const userData = { number, place, mailid: [email], npk: [0, 0, 0], farmerid: "" };
    
    // Simulate user creation process
    await createUser(email, userData);
    
    alert("User data saved!");
    setIsSubmitting(false); // End the submission process
    navigate("/dashboard", { replace: true });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div style={style.container}>
      <video
        style={style.video}
        autoPlay
        loop
        muted
        playsInline
        onError={() => console.log("Error loading video. Check file path or format.")}
      >
        <source src={require('../videos/1.mp4')} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={style.formContainer}>
        <h2 style={style.h2}>Complete Your Profile</h2>
        <input
          style={style.input}
          type="text"
          placeholder="Number"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          onFocus={(e) => e.target.style.borderColor = style.inputFocus.borderColor}
          onBlur={(e) => e.target.style.borderColor = "#66bb6a"}
        />
        <input
          style={style.input}
          type="text"
          placeholder="Place"
          value={place}
          onChange={(e) => setPlace(e.target.value)}
          onFocus={(e) => e.target.style.borderColor = style.inputFocus.borderColor}
          onBlur={(e) => e.target.style.borderColor = "#66bb6a"}
        />
        <button
          style={style.button}
          onClick={handleSubmit}
          disabled={isSubmitting} // Disable the button while submitting
        >
          {isSubmitting ? "Submitting..." : "Submit"} {/* Change button text */}
        </button>
        {(number === "" || place === "") && !isSubmitting && (
          <p style={style.alert}>Please fill in all fields.</p>
        )}
      </div>
    </div>
  );
};

export default FirstTimeLogin;
